module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 31);
/******/ })
/************************************************************************/
/******/ ({

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_ID", function() { return CHANNEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WX_ACC_TYPE", function() { return WX_ACC_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CODES_SUCCESS", function() { return CODES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CODES_ERROR_LOGIN", function() { return CODES_ERROR_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GIFT_CODE_MAP", function() { return GIFT_CODE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD_STATE", function() { return DOWNLOAD_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD_TENVIDEO_EXTRA", function() { return DOWNLOAD_TENVIDEO_EXTRA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD_CONTROLLER_STATE", function() { return DOWNLOAD_CONTROLLER_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD_CTR_FORMAT_STATE", function() { return DOWNLOAD_CTR_FORMAT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD_GAME_TYPES", function() { return DOWNLOAD_GAME_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAN_DOWNLOAD_TIPS", function() { return CAN_DOWNLOAD_TIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INSTALL_TIPS", function() { return INSTALL_TIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GAME_TYPE", function() { return GAME_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GIFT_TYPE", function() { return GIFT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GIFT_TYPE_MAP", function() { return GIFT_TYPE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWIPER_SCRIPT", function() { return SWIPER_SCRIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_STATUS", function() { return LOGIN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ORDER_TYPE", function() { return ORDER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATFORM_CONF", function() { return PLATFORM_CONF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGEXP_PHONE", function() { return REGEXP_PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGEXP_EMAIL", function() { return REGEXP_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGEXP_URL_ADDRESS", function() { return REGEXP_URL_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADTAG_REPORT_PARAMS", function() { return ADTAG_REPORT_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACT_REPORT_PARAMS", function() { return ACT_REPORT_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TENVIDEO_FROM", function() { return TENVIDEO_FROM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRATEGY", function() { return STRATEGY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRATEGY_MAP", function() { return STRATEGY_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_SYSTEM_MAP", function() { return DEFAULT_SYSTEM_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_CHANNEL_MAP", function() { return DEFAULT_CHANNEL_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD_TIPS", function() { return DOWNLOAD_TIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WAKE_APP_CONF", function() { return WAKE_APP_CONF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NO_CHANGE_LOGIN_TIPS", function() { return NO_CHANGE_LOGIN_TIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMAIN_MAP", function() { return DOMAIN_MAP; });
var CHANNEL_ID = '40038'; // 爱玩小程序场景拉起落地页上报id

var WX_ACC_TYPE = {
  iwan: 'iwan',
  honor: 'honor'
};
var CODES_SUCCESS = {
  codes: [100000, 0],
  message: '成功'
};
var CODES_ERROR_LOGIN = {
  codes: [-100008],
  message: '您的登录状态已过期，请重新登录'
};
var GIFT_CODE_MAP = {
  400001: '会员专享礼包，快去升级吧~',
  400002: '会员到期，续费会员领取吧~',
  400003: '会员等级不足，升级后可免费领取',
  400009: 'V币不足',
  508: '系统维护中',
  '-100009': '验证码错误',
  '-100008': '您的登录状态已过期，请重新登录'
};
var DOWNLOAD_STATE = {
  // 正常按钮
  normal: {
    0: '立即下载',
    10: '进入游戏',
    11: '立即安装',
    12: '立即下载',
    13: '正在下载',
    14: '继续下载',
    15: '查看',
    16: '等待',
    17: '立即下载',
    18: '等待',
    19: '立即下载',
    // 新增，客户端异常情况
    update: '立即更新',
    // 新增，进入游戏场景，增加更新判断
    gift_receive: '立即领取' // 新增，领取礼包场景
  },
  // 小按钮
  mini: {
    0: '下载',
    10: '进入',
    11: '安装',
    12: '下载',
    13: '下载中',
    14: '继续',
    15: '查看',
    16: '等待',
    17: '下载',
    18: '等待',
    19: '下载' // 新增，客户端异常情况
  }
};

/**
 * 腾讯视频 app 下载bridge的extra固定参数
 */
var DOWNLOAD_TENVIDEO_EXTRA = {
  source: 2,
  from: 99
};

/**
 * 腾讯视频 app 状态与执行方法对应关系
 */
var DOWNLOAD_CONTROLLER_STATE = {
  '-1': 'start',
  0: 'start',
  10: 'open',
  11: 'install',
  12: 'start',
  13: 'pause',
  14: 'start',
  16: 'pause',
  17: 'start',
  18: 'pause',
  19: 'start'
};

/**
 * 点击后的下载操作名称，映射 视频app 与 爱玩app格式化 的state值
 */
var DOWNLOAD_CTR_FORMAT_STATE = {
  start: [-1, 0, 12, 14, 17, 19],
  open: [10],
  install: [11],
  pause: [13, 16, 18]
};
var DOWNLOAD_GAME_TYPES = {
  1: '休闲娱乐',
  2: '动作游戏',
  3: '射击游戏',
  4: '角色扮演',
  5: '赛车游戏',
  6: '体育竞技',
  7: '策略游戏',
  8: '益智游戏',
  9: '网络游戏',
  10: '格斗游戏',
  11: '冒险游戏',
  12: '模拟经营',
  13: '棋牌游戏',
  14: '儿童游戏'
};

/**
 * 判断是否能下载提示配置
 */
var CAN_DOWNLOAD_TIPS = {
  ios: {
    online: '暂时还没有iOS下载链接哦，敬请期待~',
    url: '暂时还没有iOS下载链接哦，敬请期待~'
  },
  android: {
    online: '暂时还没有安卓下载链接哦，敬请期待~',
    url: '暂时还没有安卓下载链接哦，敬请期待~'
  }
};

/**
 * 安装提示
 */
var INSTALL_TIPS = {
  tenvideo: '腾讯视频官方认证游戏，无病毒风险'
};
var GAME_TYPE = {
  web: '1',
  // 网页游戏,
  mobile: '2',
  // 手机游戏,
  client: '3',
  // 客户端游戏
  application: '4',
  // 应用
  h5: '5',
  // H5游戏
  sdk: '8',
  // sdk游戏
  wx: '11' // wx小游戏
};
var GIFT_TYPE = {
  AMS: '7',
  CdKey: '1',
  MP: '5'
};
var GIFT_TYPE_MAP = {
  7: 'AMS',
  1: 'CdKey',
  5: 'MP'
};
var SWIPER_SCRIPT = 'https://vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/js/plugins/swiper-4.2.6.min.js';
var LOGIN_STATUS = {
  login: {
    errCode: 0,
    errMsg: 'login'
  },
  logout: {
    errCode: 0,
    errMsg: 'logout'
  },
  cancel: {
    errCode: 2,
    errMsg: 'cancel'
  },
  logoutCancelLogin: {
    errCode: 3,
    errMsg: 'logoutCancelLogin'
  }
};
var ORDER_TYPE = {
  0: 'Normal',
  // 无需手机号
  1: 'Front',
  // 手机号前置
  2: 'Behind' // 手机号后置
};

/**
 * 各个场景下的id
 * 爱玩app: iwan
 * 微信：wx
 * 腾讯视频极速版app： lite
 * 腾讯视频app： tenvideo
 * qq浏览器: qqbrowser
 * 浏览器、其它场景: browser
 */
var PLATFORM_CONF = {
  ios: {
    iwan: '3',
    wx: '4',
    lite: '9',
    tenvideo: '9',
    qq: '10',
    weishi: '9',
    sports: '9',
    yyb: '9',
    bbg: '9',
    qqbrowser: '10',
    browser: '10'
  },
  android: {
    iwan: '3',
    wx: '4',
    lite: '8',
    tenvideo: '8',
    qq: '10',
    weishi: '8',
    sports: '8',
    yyb: '8',
    bbg: '8',
    qqbrowser: '10',
    browser: '10'
  }
};
var REGEXP_PHONE = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
var REGEXP_EMAIL = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
var REGEXP_URL_ADDRESS = /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i;

/**
 * reportParams 上报参数为游戏下载提供
 * 一般在页面链接上拼接所得，部分 ADTAG（MTA提供的渠道号）对应上报的 reportParams 如下
 * {'ADTAG': 'reportParams'}
 */
var ADTAG_REPORT_PARAMS = {
  'txsp.jx-2.rk-1': 'iwan_handle_rpk',
  'txsp.jx-2.rk-2': 'iwan_handle_rpk',
  'txsp.yxpd-1.xxlhh.gd': 'iwan_hpaddle-more_rpk',
  'txsp.yxpd-2.xxlhh.gd': 'iwan_hpaddle-more_rpk',
  'txsp.grzx-2.jdyx-1': 'iwan_personal_rpk',
  'txsp.grzx-1.jdyx': 'iwan_personal_rpk'
};
var ACT_REPORT_PARAMS = {
  app_inner: 'iwan_activity_rpk',
  app_outer: 'iwan_activity-out_rpk'
};
var TENVIDEO_FROM = {
  iwan: 30158,
  h5game: 30170
};
var STRATEGY = {
  ACCESS: 1,
  CAPTCHA: 2,
  DENY: 128
};
var STRATEGY_MAP = {
  1: 'ACCESS',
  2: 'CAPTCHA',
  128: 'DENY'
};

// 没有区服信息返回的系统参数时，前端根据ua默认自动获取，提供接口默认值
var DEFAULT_SYSTEM_MAP = {
  ios: '0',
  android: '1'
};

// 没有区服信息返回的登录类型参数时，前端根据用户登录默认自动获取，提供接口默认值
var DEFAULT_CHANNEL_MAP = {
  wx: '1',
  qq: '2'
};
var DOWNLOAD_TIPS = {
  ios: {
    downloadUrl: '暂时还没有iOS下载链接哦，敬请期待~'
  },
  android: {
    downloadUrl: '暂时还没有安卓下载链接哦，敬请期待~'
  }
};
var WAKE_APP_CONF = {
  tenvideo: {
    wxAppID: 'wxca942bbff22e0e51',
    scheme: 'tenvideo2://',
    openKey: 'openurl',
    extParams: {
      action: 65,
      from: 30158
    },
    android: {
      packageUrl: 'tenvideo2://can_open_me_if_install_and_regeister_this_scheme',
      packageName: 'com.tencent.qqlive',
      downloadUrl: 'http://mcgi.v.qq.com/commdatav2',
      params: {
        cmd: 4,
        confid: 2555,
        platform: 'aphone'
      }
    },
    ios: {
      packageUrl: 'tenvideo2://can_open_me_if_install_and_regeister_this_scheme',
      packageName: 'com.tencent.live4iphone',
      downloadUrl: 'https://itunes.apple.com/cn/app/id458318329',
      params: {
        mt: 8
      }
    }
  },
  lite: {
    wxAppID: 'wx434fd146a665ff62',
    scheme: 'videolite://v.qq.com/H5AiwanGameCenterActivity',
    openKey: 'url',
    android: {
      packageUrl: 'videolite://',
      packageName: 'com.tencent.videolite.android',
      downloadUrl: 'http://mcgi.v.qq.com/commdatav2',
      params: {
        cmd: 76,
        confid: 20111,
        platform: 'aphone'
      }
    },
    ios: {
      packageUrl: 'videolite://',
      packageName: 'com.tencent.videoplus.iphone',
      downloadUrl: 'https://itunes.apple.com/cn/app/id1462049868',
      params: {
        mt: 8
      }
    }
  },
  iwanapp: {
    wxAppID: 'wx3d92c9a93e6e08f4',
    scheme: 'txiwan://txiwan/',
    openKey: 'openurl',
    extParams: {},
    android: {
      packageUrl: 'txiwan://can_open_me_if_install_and_regeister_this_scheme',
      packageName: 'iwan.tencent.com',
      downloadUrl: 'https://imtt.dd.qq.com/16891/apk/0DF3550F7A9F56D58F0F43004858736F.apk?fsname=iwan.tencent.com_2.6.4_264.apk',
      params: {}
    },
    ios: {}
  }
};
var NO_CHANGE_LOGIN_TIPS = {
  sports: '请在"我的-设置"中切换登录～',
  weishi: '请在"我"的页卡中切换登录～'
};
var DOMAIN_MAP = {
  yyb: 'yyb.qq.com',
  bbg: 'bbg.qq.com',
  ac: 'ac.qq.com',
  weishi: 'weishi.qq.com'
};

/***/ })

/******/ });